import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faFileExcel, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const Container =styled.div`

   display: inline-flex;
  align-items: center;


.table-icon {
  font-size: 20px;
  color: #ccc;
}

.excel-icon {
  font-size: 20px;
   color: #ccc;
  margin-right: 0px; /* Spacing between the Excel icon and the arrow */
}

.arrow-icon {
  font-size: 15px;
   color: #ccc;
  margin:0 4px;
  
}
`;

const ExcelImportIcon = () => (
  
     <Container className="excel-import-icon">
    <FontAwesomeIcon icon={faFileExcel} className="excel-icon" />
    <FontAwesomeIcon icon={faArrowRight} className="arrow-icon" />
    <FontAwesomeIcon icon={faTable} className="table-icon" />
  
  </Container>
);

export default ExcelImportIcon;